import React, { ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';

type Props = {
  loading: boolean;
  children?: ReactNode;
};

const Content = ({ loading, children }: Props): JSX.Element => (
  <>
    {loading ? (
      <div className="spinner-wrapper">
        <Spinner animation="border" className="spinner" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    ) : (
      children
    )}
  </>
);

export default Content;
